export default __webpack_public_path__ + "static/media/UNIBIT-WIDE-COLORED-TEXT 1.d54dda60.png";